const ORDER_SCOPE = 1
const STORE_SCOPE = 2
const PRODUCT_SCOPE = 3

export default {
    ORDER_SCOPE,
    STORE_SCOPE,
    PRODUCT_SCOPE,
}
